import { useEffect } from "react";
import "@/App.css";

const REDIRECT_URL = "https://horus-stability.preview.emergentagent.com";

export default function App() {
  useEffect(() => {
    const t = setTimeout(() => {
      window.location.replace(REDIRECT_URL);
    }, 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="horus-loader" data-testid="horus-redirect-loader">
      <div className="horus-ring" data-testid="horus-spinner" />
      <div className="horus-text" data-testid="horus-loading-text">
        Loading HORUS AI Tour Guide...
      </div>
    </div>
  );
}
